module.exports = __webpack_public_path__ + "static/media/trending1.b5b738a5.png";